import { authHeader, handleResponse } from '../helpers'

export const scriptitemService = {
  getScriptItems,
  getScriptItem,
  createScriptItem,
  updateScriptItem,
  deleteScriptItem
}

function getScriptItems(payload) {
  let eventId = payload
  if (typeof payload === 'object') {
    eventId = payload.eventId
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  let url = process.env.VUE_APP_API_URL + '/scripts/' + eventId

  if (payload.excludeUncorfirmed) {
    url += '?excludeUncorfirmed=' + payload.excludeUncorfirmed
  }

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((response) => {
      var items = response.items
      return items
    })
}

function getScriptItem(itemId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/script/' + itemId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}

function createScriptItem(itemData) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: itemData
  }
  return fetch(process.env.VUE_APP_API_URL + '/script', requestOptions)
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}

function updateScriptItem(itemId, itemData) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: itemData
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/script/' + itemId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}

function deleteScriptItem(itemId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return fetch(
    process.env.VUE_APP_API_URL + '/script/' + itemId,
    requestOptions
  )
    .then(handleResponse)
    .then((response) => {
      var item = response
      return item
    })
}
